import { action } from 'easy-peasy';
import { IActionSetTemplate } from '../types';

const setTemplate: IActionSetTemplate = action((state, payload) => {
  state.item = payload;
});

export default setTemplate;
